<app-ace-select
  #aceSelect
  [ngbTooltip]="(selectedNetworkProviderTypes?.length > MAX_ITEMS) && tipContent"
  placement="left"
  [items]="networkProviderTypes"
  [multiSelect]="multiSelect"
  [bindLabel]="'network_provider_type_name'"
  [bindValue]="bindToTypeId ? 'network_provider_type_id' : null"
  [placeholder]="placeholder"
  [loading]="loading"
  [compareWith]="bindToTypeId ? null : compareFn"
  [hideSelected]="true"
  [appendTo]="appendTo">

  @if (!multiSelect) {
    <ng-template #labelTemplate let-item="item" let-clear="clear">
      <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
      <span class="ng-value-label" [title]="item.network_provider_type_name">{{item.network_provider_type_name}}</span>
    </ng-template>
  } @else {
    <ng-template #multiLabelTemplate let-items="items" let-clear="clear">
      @if (items.length <= MAX_ITEMS) {
        <div>
          @for (item of items; track item.network_provider_type_id) {
            <div class="ng-value">
              <span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
              <span class="ng-value-label" [title]="item.network_provider_type_name">{{item.network_provider_type_name}}</span>
            </div>
          }
        </div>
      } @else {
        <div>
          <div class="ng-value">
            <span class="ng-value-label">{{ 'X Selected' | messageTranslate:{n: items.length} }}</span>
          </div>
        </div>
      }
    </ng-template>
  }

  <ng-template #optionTemplate let-item="item">
    <span class="ng-value-label" [title]="item.network_provider_type_name">{{item.network_provider_type_name}}</span>
  </ng-template>

  <ng-template #tipContent>
    <table class="cim-tooltip">
      <!-- TODO: KQ: improve track property -->
      @for (item of selectedNetworkProviderTypes; track item) {
        <tr>
          <td>{{ item.network_provider_type_name }}</td>
        </tr>
      }
    </table>
  </ng-template>

</app-ace-select>
